import { render, staticRenderFns } from "./ActionDelete.vue?vue&type=template&id=5a084f60&"
import script from "./ActionDelete.vue?vue&type=script&lang=js&"
export * from "./ActionDelete.vue?vue&type=script&lang=js&"
import style0 from "./ActionDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports